module.exports = __webpack_public_path__ + "static/media/girl.e24c8aeb.png";